import { render, staticRenderFns } from "./r-item-social-dialog.vue?vue&type=template&id=49bb851a"
import script from "./r-item-social-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-social-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bb851a')) {
      api.createRecord('49bb851a', component.options)
    } else {
      api.reload('49bb851a', component.options)
    }
    module.hot.accept("./r-item-social-dialog.vue?vue&type=template&id=49bb851a", function () {
      api.rerender('49bb851a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/items-social/r-item-social-dialog.vue"
export default component.exports